"use strict";function queryMeetingRoomList$(e){return ddSdk_1.ddSdk.invokeAPI(apiName,e)}var _a;Object.defineProperty(exports,"__esModule",{value:!0}),exports.queryMeetingRoomList$=void 0;var ddSdk_1=require("../../../lib/ddSdk"),apiName="biz.iot.queryMeetingRoomList";ddSdk_1.ddSdk.setAPI(apiName,(_a={},_a[ddSdk_1.ENV_ENUM.ios]={vs:"4.6.34"},_a[ddSdk_1.ENV_ENUM.android]={vs:"4.6.34"},_a)),exports.queryMeetingRoomList$=queryMeetingRoomList$,exports.default=queryMeetingRoomList$;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@2.13.71@dingtalk-jsapi/api/biz/iot/queryMeetingRoomList.js
// module id = 959
// module chunks = 106